

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   updateLeaveTypeAdmin,
//   fetchLeaveTypes,
// } from "../../redux/actions/leaveTypeActions";
// import { fetchDesignations } from "../../redux/actions/designationActions";
// import toast from "react-hot-toast";

// const EditLeaveTypeModal = ({ leaveType, onClose }) => {
//   const dispatch = useDispatch();
//   const [name, setName] = useState(leaveType.name);
//   const [description, setDescription] = useState(leaveType.description);
//   const [status, setStatus] = useState(leaveType.status);
//   const [policies, setPolicies] = useState(
//     leaveType.policies.map((p) => ({ ...p }))
//   );

//   const { designations } = useSelector((state) => state.designation || {});

//   useEffect(() => {
//     dispatch(fetchDesignations());
//   }, [dispatch]);

//   const handlePolicyChange = (index, field, value) => {
//     setPolicies((prev) => {
//       const updated = [...prev];
//       updated[index] = {
//         ...updated[index],
//         [field]: field === "total_leaves" ? parseInt(value || 0, 10) : value,
//       };
//       return updated;
//     });
//   };

//   const handleAddPolicy = () => {
//     setPolicies((prev) => [...prev, { designation: "", total_leaves: 0 }]);
//   };

//   const handleRemovePolicy = (index) => {
//     setPolicies((prev) => prev.filter((_, i) => i !== index));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     dispatch(updateLeaveTypeAdmin(leaveType.id, name, description, status, policies))
//       .then(() => {
//         dispatch(fetchLeaveTypes());
//         toast.success("Leave type updated");
//         onClose();
//       })
//       .catch(() => {
//         toast.error("Update failed");
//       });
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="bg-white p-6 rounded-lg w-full max-w-xl shadow-lg">
//         <h2 className="text-lg font-semibold mb-4">Edit Leave Type</h2>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div>
//             <label className="block text-sm font-medium">Name</label>
//             <input
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               className="w-full p-2 border rounded"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium">Description</label>
//             <input
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               className="w-full p-2 border rounded"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium">Status</label>
//             <select
//               value={status}
//               onChange={(e) => setStatus(e.target.value)}
//               className="w-full p-2 border rounded"
//             >
//               <option value="active">Active</option>
//               <option value="inactive">Inactive</option>
//             </select>
//           </div>

//           <div>
//             <label className="block text-sm font-medium mb-2">Policies</label>
//             {policies.map((policy, i) => (
//               <div key={i} className="flex items-center gap-2 mb-2">
//                 <select
//                   value={policy.designation}
//                   onChange={(e) =>
//                     handlePolicyChange(i, "designation", e.target.value)
//                   }
//                   className="p-2 border rounded w-1/2"
//                 >
//                   <option value="">Select designation</option>
//                   {designations?.map((designation, idx) => (
//                     <option key={idx} value={designation}>
//                       {designation}
//                     </option>
//                   ))}
//                 </select>
//                 <input
//                   type="number"
//                   min="0"
//                   placeholder="Total Leaves"
//                   value={policy.total_leaves}
//                   onChange={(e) =>
//                     handlePolicyChange(i, "total_leaves", e.target.value)
//                   }
//                   className="p-2 border rounded w-1/3"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => handleRemovePolicy(i)}
//                   className="text-red-500 hover:underline text-xs"
//                 >
//                   Remove
//                 </button>
//               </div>
//             ))}

//             {/* 🔽 Add Policy Button */}
//             <button
//               type="button"
//               onClick={handleAddPolicy}
//               className="text-sm text-blue-600 hover:underline mt-2"
//             >
//               + Add Policy
//             </button>
//           </div>

//           <div className="flex justify-end gap-3 mt-4">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 py-2 bg-gray-300 rounded"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//             >
//               Update
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditLeaveTypeModal;


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateLeaveTypeAdmin,
  fetchLeaveTypes,
} from "../../redux/actions/leaveTypeActions";
import { fetchDesignations } from "../../redux/actions/designationActions";
import toast from "react-hot-toast";

const EditLeaveTypeModal = ({ leaveType, onClose }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(leaveType.name);
  const [description, setDescription] = useState(leaveType.description);
  const [status, setStatus] = useState(leaveType.status);
  const [policies, setPolicies] = useState(
    leaveType.policies.map((p) => ({ ...p }))
  );

  const { designations } = useSelector((state) => state.designation || {});

  useEffect(() => {
    dispatch(fetchDesignations());
  }, [dispatch]);

  const handlePolicyChange = (index, field, value) => {
    setPolicies((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: field === "total_leaves" ? parseInt(value || 0, 10) : value,
      };
      return updated;
    });
  };

  const handleAddPolicy = () => {
    setPolicies((prev) => [...prev, { designation: "", total_leaves: 0 }]);
  };

  const handleRemovePolicy = (index) => {
    setPolicies((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(updateLeaveTypeAdmin(leaveType.id, name, description, status, policies))
      .then(() => {
        dispatch(fetchLeaveTypes());
        toast.success("Leave type updated");
        onClose();
      })
      .catch(() => {
        toast.error("Update failed");
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
      <div className="bg-white p-6 rounded-lg w-full max-w-xl shadow-lg my-8 max-h-[90vh] overflow-y-auto">
        <h2 className="text-lg font-semibold mb-4">Edit Leave Type</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium">Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Description</label>
            <input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full p-2 border rounded"
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Policies</label>
            {policies.map((policy, i) => (
              <div
                key={i}
                className="flex flex-col md:flex-row md:items-center gap-2 mb-2"
              >
                <select
                  value={policy.designation}
                  onChange={(e) =>
                    handlePolicyChange(i, "designation", e.target.value)
                  }
                  className="p-2 border rounded w-full md:w-1/2"
                >
                  <option value="">Select designation</option>
                  {designations?.map((designation, idx) => (
                    <option key={idx} value={designation}>
                      {designation}
                    </option>
                  ))}
                </select>
                <input
                  type="number"
                  min="0"
                  placeholder="Total Leaves"
                  value={policy.total_leaves}
                  onChange={(e) =>
                    handlePolicyChange(i, "total_leaves", e.target.value)
                  }
                  className="p-2 border rounded w-full md:w-1/3"
                />
                <button
                  type="button"
                  onClick={() => handleRemovePolicy(i)}
                  className="text-red-500 hover:underline text-xs md:w-auto"
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={handleAddPolicy}
              className="text-sm text-blue-600 hover:underline mt-2"
            >
              + Add Policy
            </button>
          </div>

          <div className="flex justify-end gap-3 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditLeaveTypeModal;
